import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _hoisted_1 = { class: "row flex-center py-4" }
const _hoisted_2 = { class: "col-sm-10 col-md-8 col-lg-6 col-xl-5 col-xxl-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "d-flex flex-center mb-4",
  href: "https://www.latudio.com"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "latudio-logo",
    width: "400",
    height: "120"
  })
], -1)
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-body p-4 p-sm-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "row flex-between-center mb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
    /*#__PURE__*/_createElementVNode("h5", null, "Log in")
  ])
], -1)
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "row flex-between-center d-none" }
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "form-check mb-0" }
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "col-auto" }
const _hoisted_15 = { class: "row flex-between-center" }
const _hoisted_16 = { class: "col-auto" }
const _hoisted_17 = ["textContent"]
const _hoisted_18 = { class: "col-auto" }
const _hoisted_19 = { class: "fs--1 text-600 fw-bolder" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_Form, {
            id: "login-form",
            onSubmit: _ctx.processForm,
            "validation-schema": _ctx.schema
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Input, {
                  id: "authentication-email",
                  class: "form-floating",
                  label: _ctx.$t('authentication.email'),
                  name: "email",
                  type: "email",
                  placeholder: "name@example.com",
                  error: errors.email,
                  floatingLabel: ""
                }, null, 8, ["label", "error"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Input, {
                  id: "authentication-password",
                  class: "form-floating",
                  label: _ctx.$t('authentication.password'),
                  name: "password",
                  type: "password",
                  placeholder: "password",
                  error: errors.password,
                  floatingLabel: ""
                }, null, 8, ["label", "error"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_Field, {
                    name: "rememberMe",
                    type: "checkbox",
                    class: "form-control",
                    value: true
                  }, {
                    default: _withCtx(({ field }) => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("input", _mergeProps({
                          id: "authentication-remember-me",
                          class: "form-check-input",
                          name: "rememberMe",
                          type: "checkbox"
                        }, field, { value: true }), null, 16),
                        _createElementVNode("label", {
                          class: "form-check-label",
                          for: "authentication-remember-me",
                          textContent: _toDisplayString(_ctx.$t('authentication.remember-me'))
                        }, null, 8, _hoisted_12)
                      ]),
                      _createElementVNode("div", {
                        class: "text-danger text-sm",
                        textContent: _toDisplayString(errors.rememberMe)
                      }, null, 8, _hoisted_13)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_router_link, {
                      class: "fs--1",
                      to: "/forgot-password",
                      textContent: _toDisplayString(_ctx.$t('authentication.forgot-password') + '?')
                    }, null, 8, ["textContent"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", {
                    class: "fs--1 text-600 fw-bolder",
                    textContent: _toDisplayString(_ctx.$t('authentication.do-not-have-an-account-yet'))
                  }, null, 8, _hoisted_17)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: "/register",
                      textContent: _toDisplayString(_ctx.$t('authentication.create-account'))
                    }, null, 8, ["textContent"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "btn btn-primary d-block w-100 mt-3",
                  type: "submit",
                  name: "submit",
                  textContent: _toDisplayString(_ctx.$t('authentication.login'))
                }, null, 8, _hoisted_21)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ])
  ]))
}